import { useEffect, useRef, useState } from "react";
import Axios from "axios";

interface IOption {
    app: string;
    model: string;
}

interface IOptions {
    [key: string]: IOption;
}

interface IUseGetGetModelFormData<T> {
    options: IOptions;
    mapFormData?: (data: T) => any;
    afterFetch?: Function;
    triggerValues?: any[];
    shouldFetch?: any;
}

// options eq: options: { status: { app: "demand", model: "SupplierContract" } },
export function useGetModelFormData<T = unknown>({
    options,
    mapFormData,
    afterFetch,
    triggerValues = [],
    shouldFetch = undefined,
}: IUseGetGetModelFormData<T>) {
    const [formData, setFormData] = useState<T | undefined | null>(undefined);

    useEffect(() => {
        const getFormData = async () => {
            try {
                const response = await Axios.post("filter-options-prime", options);
                const data = response.data.data ? response.data.data : response.data;
                const mappedFormData = mapFormData ? mapFormData(data) : data;
                setFormData(mappedFormData);
                afterFetch && afterFetch(mappedFormData);
            } catch {}
        };

        shouldFetch != false && Object.keys(options).length > 0 && getFormData();
    }, [...triggerValues, shouldFetch]);

    return { formData };
}
